import DetailsCard from './DetailsCard'
import PaymentList from './PaymentList'
import AmountCard from './AmountCard'
import { PaymentListProvider } from '../context/Listprovider'
const CashierPage = () => {
  return (
    <PaymentListProvider>
      <div className='pt-3 px-2 pb-2 flex flex-col  gap-y-2'>
              <DetailsCard/>
              <AmountCard/>
              <PaymentList/>
      </div>
    </PaymentListProvider>
  )
}

export default CashierPage
